import { InitializePaymentInterface } from "../types";
import { PaymentInterface } from "./paymentInterface";
import { Stripe, loadStripe } from "@stripe/stripe-js";

export class StripePayment implements PaymentInterface {
  initToken: string;
  isPaypalEnabled: boolean;
  deleteCardAllowed: boolean;
  setDisplayLoader?: Function | undefined;
  setPayButtonDisabled: Function;
  setPaymentError: Function;
  setPaymentNonce: Function;
  publicKey: string;
  stripePromise?: Promise<Stripe | null>;

  constructor(paymentInitialize: InitializePaymentInterface) {
    this.initToken = paymentInitialize.apiPaymentInitToken.initToken;
    this.isPaypalEnabled = paymentInitialize.apiPaymentInitToken.isPaypalEnabled;
    this.deleteCardAllowed = paymentInitialize.apiPaymentInitToken.deleteCardAllowed;
    this.setDisplayLoader = paymentInitialize.setDisplayLoader;
    this.setPayButtonDisabled = paymentInitialize.setPayButtonDisabled;
    this.setPaymentError = paymentInitialize.setPaymentError;
    this.setPaymentNonce = paymentInitialize.setPaymentNonce;
    this.publicKey = paymentInitialize.apiPaymentInitToken.publicKey as string;
    this.stripePromise = loadStripe(this.publicKey);
  }

  initialize(): void {}

  getTokenForPayment(): void {}

  retryGetTokenForPayment(): void {}
}
